import { DesktopHeader } from './DesktopHeader'
import type { HeaderProps } from './Header.Types'
import { MobileHeader } from './MobileHeader'

const Header = ({
  headerImages,
  headline,
  subheadline,
  button,
  shouldShowRating,
}: HeaderProps) => {
  return (
    <>
      <MobileHeader
        headerImages={headerImages}
        headline={headline}
        subheadline={subheadline}
        button={button}
        shouldShowRating={shouldShowRating}
      />
      <DesktopHeader
        headerImages={headerImages}
        headline={headline}
        subheadline={subheadline}
        button={button}
        shouldShowRating={shouldShowRating}
      />
    </>
  )
}

export default Header
